import React from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useNavigation, useRoute, RouteProp } from '@react-navigation/native';
import type { StackNavigationProp } from '@react-navigation/stack';
import type { RootStackParamList } from '@/navigation/RootNavigator';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { UnifiedModal } from '@/components/common/UnifiedModal';
import ResidentCreateConversation from '@/components/residents/propertyChat/ResidentCreateConversation';

type Nav = StackNavigationProp<RootStackParamList, 'NewConversation'>;
type Route = RouteProp<RootStackParamList, 'NewConversation'>;

export const NewConversationScreen: React.FC = () => {
  const navigation = useNavigation<Nav>();
  const route = useRoute<Route>();
  const insets = useSafeAreaInsets();
  const { colors } = useThemeColors();
  const initialSubject = route.params?.initialSubject;

  const handleClose = () => {
    navigation.goBack();
  };

  const handleCreated = (conversationId: number, subject?: string) => {
    navigation.replace('Conversation', { conversationId, subject });
  };

  return (
    <View style={{ flex: 1, paddingTop: insets.top, backgroundColor: colors.bg.modal }}>
      <UnifiedModal
        visible
        onClose={handleClose}
        variant="fullscreen"
        animateEntry={false}
        title="Start Conversation"
        avoidKeyboard
        compensateKeyboardToolbar
        scrollable={false}
      >
        <ResidentCreateConversation
          onClose={handleClose}
          onCreated={handleCreated}
          initialSubject={initialSubject}
        />
      </UnifiedModal>
    </View>
  );
};

export default NewConversationScreen;
